import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const KidsInfo = () => {
  const [kidsInfo, setKidsInfo] = useState({
    have_kids: '',
    want_kids: '',
    flexible_on_kids: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/kids-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No kids info found. Please set your kids info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch kids info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const kidsData = data.reduce((acc, item) => {
            if (item.question_text === 'Do you have any kids?')
              acc.have_kids = item.answer_text;
            if (item.question_text === 'Do you want kids?')
              acc.want_kids = item.answer_text;
            if (item.question_text === 'Are you flexible on this?')
              acc.flexible_on_kids = item.answer_text;
            return acc;
          }, {});
          setKidsInfo(kidsData);
        }
      })
      .catch((error) => {
        console.error('Error fetching kids info:', error);
        setMessage('Error fetching kids info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();
    const payload = {
      have_kids: kidsInfo.have_kids,
      want_kids: kidsInfo.want_kids,
      flexible_on_kids: kidsInfo.flexible_on_kids,
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/kids-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update kids info');
      }

      setKidsInfo(payload);
      setMessage('Kids info updated successfully.');

      setTimeout(() => {
        navigate('/ethnicity-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting kids info:', error);
      setMessage('Failed to update kids info.');
    }
  };

  const handleChange = (e) => {
    setKidsInfo({
      ...kidsInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Kids Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you have any kids?
                <select
                  name="have_kids"
                  value={kidsInfo.have_kids || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you want kids?
                <select
                  name="want_kids"
                  value={kidsInfo.want_kids || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Maybe">Maybe</option>
                  <option value="Not for a little while">
                    Not for a little while
                  </option>
                </select>
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Are you flexible on this?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexible_on_kids"
                    value="Yes"
                    checked={kidsInfo.flexible_on_kids === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexible_on_kids"
                    value="Maybe"
                    checked={kidsInfo.flexible_on_kids === 'Maybe'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Maybe</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="flexible_on_kids"
                    value="No"
                    checked={kidsInfo.flexible_on_kids === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/political-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default KidsInfo;
